import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../providers/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  bulletinConfigurationUrl = '/fusionui/bulletin';
  constructor(private apiService: ApiService) {}

  //eslint-disable-next-line
  getBulletinConfiguration$(): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.get$<any>(this.bulletinConfigurationUrl, {});
  }
  //eslint-disable-next-line
  saveBulletinConfiguration$(data: any): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(this.bulletinConfigurationUrl, data);
  }
}
